import React from 'react'

import { isNull } from '@app/utils'

import { PriceDifference } from './PriceDifference'

import type { ReactNode } from 'react'

interface PriceDifferenceRenderOptions {
  priceDifference: number | null
}

export const priceDifferenceRender = (_: unknown, { priceDifference }: PriceDifferenceRenderOptions): ReactNode => {
  if (isNull(priceDifference)) return

  return <PriceDifference priceDifference={ priceDifference } />
}
